const loadDavinci = () => {
  const hasScript = document.getElementById('davincibase');
  if (!hasScript) {
    const scr = document.createElement('script');
    scr.src =
      'https://static.dvinci-easy.com/files/job-widget-v2/dvinci-job-widget-2.0.0.min.js';
    scr.id = 'davincibase';
    document.body.appendChild(scr);
  }
};

export default loadDavinci;
